import { utcToZonedTime } from 'date-fns-tz';

export default function (date = new Date()) {
    return utcToZonedTime(date, window.AppConfig.timezone || 'Australia/Sydney');
}
